import React from 'react';
import { useField } from 'formik';
import { CheckboxGroupRaw } from '../../../../Inputs';
import { WhatNeedsUpdating } from './use-addendum-form.hook';

const OPTIONS = [
  { label: 'Clarification only', value: 'clarify' },
  { label: 'CPT codes', value: 'cpt' },
  { label: 'Diagnosis', value: 'dx' },
];

export function applyWhatNeedsUpdatingExclusivity(
  prev: WhatNeedsUpdating[],
  next: WhatNeedsUpdating[]
): WhatNeedsUpdating[] {
  const clarifyJustChecked = next.includes('clarify') && !prev.includes('clarify');
  let result: WhatNeedsUpdating[] = clarifyJustChecked ? [ 'clarify' ] : next.filter(v => v !== 'clarify');

  if (!result.includes('cpt') && !result.includes('dx')) {
    result = [ 'clarify', ...result ];
  }

  return Array.from(new Set(result));
}

export const AddendumWhatNeedsUpdating: React.VFC = () => {
  const [ field, , helpers ] = useField<WhatNeedsUpdating[]>('whatNeedsUpdating');

  return (
    <CheckboxGroupRaw
      label="What needs to be updated?"
      options={OPTIONS}
      value={field.value}
      setValue={(next) => helpers.setValue(applyWhatNeedsUpdatingExclusivity(field.value, next as WhatNeedsUpdating[]))}
    />
  );
};
